import {defineStore} from 'pinia'
import {useUserStore} from "@/stores/user";
import router from "@/router";

export const useMediaStore = defineStore('media', {
    // a function that returns a fresh state
    state: () => ({
        // object: typeof localStorage[constants.AUTH_TOKEN_NAME] === "undefined" ? Object.loggedOutObject() : Object.from(localStorage[constants.AUTH_TOKEN_NAME]),
        assets: [],
        page: 1,
        size: 12,
        total: 0,
        filters: {
            category_ids: [],
            search: '',
            type: []
        },
    }),
    // optional getters
    getters: {},
    // optional actions
    actions: {
        createAsset(kdnr, assetData) {
            const formData = new FormData(); // pass data as a form
            formData.append('kdnr', kdnr);
            formData.append("asset[file]", assetData.file)
            formData.append("asset[alt_text]", assetData.altText)
            formData.append("asset[copyright]", assetData.copyright)
            formData.append("asset[copyright_confirmed]", true)
            const conf = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            return this.apiClient.post(`/assets`, formData, conf);
        },
        getAssets(kdnr) {
            let params = {
                kdnr: kdnr || useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr,
                page: this.page,
                size: this.size
            }
            params = this.applyFilters(params)
            return this.apiClient
              .get(`/assets`, { params })
              .then(({ data }) => {
                this.assets = data.assets;
                this.page = data.page;
                this.total = data.total;
                return data;
              }).catch(console.error);
        },
        get(id, kdnr) {
            return this.apiClient.get(`/assets/${id}?kdnr=${kdnr}`);
        },
        update(id, kdnr, values) {
            const currentAsset = this.assets.find((asset) => asset.id === Number(id));
            return this.apiClient.put(`/assets/${id}`, {
              kdnr,
              asset: {
                  ...values.asset,
                  lock_version: values.asset.lock_version ?? currentAsset?.lock_version,
              },
            });
        },
        deleteAsset(id, kdnr) {
            return this.apiClient
              .delete(`/assets/${id}`, { params: { kdnr } })
              .then(({ data }) => {
                if (data.success) {
                  this.assets = this.assets.filter((asset) => {
                    return asset.id !== Number(id);
                  });
                  this.total = Math.max(this.total - 1, 0);
                }
                return data;
              });
        },

        applyFilters(params) {
            Object.keys(this.filters).forEach(key => {
                const value = this.filters[key];
                if(value.length > 0) {
                    if(value instanceof Array) {
                        params[key] = value.join(',');
                    } else {
                        params[key] = value;
                    }

                }
            });
            return params;
        }
    }
})
